const Dashboard = require("../components/Dashboard");
const { connect } = require("react-redux");
const { fetchPromoCodes } = require("actions/promocodes");

module.exports = connect(
    state => ({
        isFetching: state.promocodes.isFetching,
        items: state.promocodes.items,
        hasFetchedAll: state.promocodes.hasFetchedAll
    }),
    { fetchPromoCodes }
)(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/admin-dashboard/containers/Dashboard.js